export default [
    {
        _name: "CSidebarNav",
        _children: [
            {
                _name: "CSidebarNavItem",
                keyStr : "PurchaseSearchList",
                name: "招標管理",
                to: "/",
            },
            // {
            //     _name: "CSidebarNavItem",
            //     keyStr : "RFQSearchList",
            //     name: "詢價單管理",
            //     to: "/rfqsearchlist",
            // },
            {
                _name: "CSidebarNavItem",
                keyStr : "RequestSearchList",
                name: "詢價需求單管理",
                to: "/requestsearchlist",
            },
            {
                _name: "CSidebarNavItem",
                keyStr : "SupplierSearchList",
                name: "詢價單管理",
                to: "/suppliersearchlist",
            },
            {
                _name: "CSidebarNavItem",
                keyStr : "OrderSearch",
                name: "訂單與狀況查詢",
                to: "/ordersearch",
            },
            {
                _name: "CSidebarNavItem",
                keyStr : "ChangeOrder",
                name: "訂單變更查詢",
                to: "/changeorder",
            },
            {
                _name: "CSidebarNavItem",
                keyStr : "Delivery",
                name: "出貨單列印",
                to: "/delivery",
            },
            {
                _name: "CSidebarNavItem",
                keyStr : "ScheduleLine",
                name: "schedule line",
                to: "/scheduleline",
            },
            {
                _name: "CSidebarNavItem",
                keyStr : "Statement",
                name: "對帳單查詢",
                to: "/statement",
            },
            {
                _name: "CSidebarNavItem",
                keyStr : "Account",
                name: "帳款查詢",
                to: "/account",
            },            
            {
                    _name: "CSidebarNavDropdown",
                    keyStr : "Quality",
                    name: "品質需求",
                    // icon: "cil-settings",
                    items: [
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "PlanMasterFile",
                            name: "計畫主檔",
                            to: "/plan_masterfile",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "TrialProduction",
                            name: "試作準備",
                            to: "/trialproduction",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "TentativePreparationReport",
                            name: "試作準備報表",
                            to: "/tentativepreparationreport",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "COA",
                            name: "COA 上傳",
                            to: "/coa",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "JQM",
                            name: "JQM 上傳",
                            to: "/jqm",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "GeneralTable",
                            name: "COA&CAR&JQM審核總表",
                            to: "/generaltable",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "Element",
                            name: "部材品質異常聯絡單",
                            to: "/element",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "QBR",
                            name: "QBR",
                            to: "/qbr",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "QDFMForm",
                            name: "QDFMForm",
                            to: "/qdfmform",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "QFM",
                            name: "QFM",
                            to: "/qfm",
                        },
                        {
                            _name: "CSidebarNavItem",
                            keyStr : "CheckScore",
                            name: "供應商出貨檢驗數據上傳",
                            to: "/checkscore",
                        },
                    ],
            },
            {
                _name: "CSidebarNavItem",
                keyStr : "SysLogFile",
                name: "資料交換管理介面",
                to: "/syslogfile",
            }
        ],
    },
];
